import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IInsertBlockAtIndex } from '../../../action/block.action';

export const insertBlockAtIndex = (index: number, block?: IInsertBlockAtIndex['block']) => returnAction<IInsertBlockAtIndex>(ActionEnum.INSERT_BLOCK_AT_INDEX, {
  index,
  block
});
